import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';

import { TextContext } from '@/utils/contexts/TextContext';
import { ModalContext } from '@/utils/contexts/ModalContext';
import { appActions } from "@/store/actions/app.actions";

import useWindowIsMobile from '@/utils/hooks/useWindowIsMobile';

const LetterLogic = ({ children }) => {
	const dispatch = useDispatch();
	const { contextDispatch, contextState } = useContext(TextContext);
	const { id: letterId } = useParams();

	const { setModalAdditionalInfo, modalAdditionalInfo, showModal, closeModal } = useContext(ModalContext);
	const modalInfo = useSelector(state => state.app.modalInfo);

	const isMobile = useWindowIsMobile();

	useEffect(() => {
		// when 'reload' comes from modal Info
		if (modalInfo === 'reload') {
			contextDispatch({ type: 'fetchLetter', payload: { letterId } });
			dispatch(appActions.setModalInfo(''));
		}
		// eslint-disable-next-line
    }, [modalInfo]);

	useEffect(() => {
		// first load data
		if (letterId) {
			contextDispatch({ type: 'fetchLetter', payload: { letterId } });
		}
		// eslint-disable-next-line
    }, [letterId]);

	useEffect(() => {
		// handle multiple events
		if (contextState.eventObject) {
			switch (contextState.eventObject.type) {
				case 'showModalDeleteChange':
					showModal({
						componentName: 'ModalDeleteChange',
						additionalInfo: {
							changeId: contextState.eventObject.changeId,
						},
					});
					contextDispatch({ type: 'resetEventObject' });
					break;
				case 'editAdded':
					contextDispatch({ type: 'loadChangesHistory', payload: { changeId: parseInt(contextState.currentChangesHistory.changeId) } });
					contextDispatch({ type: 'resetEventObject' });
					break;
				case 'reloadHistory':
					contextDispatch({
						type: 'loadChangesHistory', payload: {
							changeId: contextState.eventObject.payload.changeId,
						},
					});
					break;
				default:
					// eslint-disable-next-line no-console
					console.log('none');
			}
		}
		// eslint-disable-next-line
    }, [contextState.eventObject]);

	useEffect(() => {
		contextDispatch({ type: 'setIsMobile', payload: { isMobile } });
		// eslint-disable-next-line
    }, [isMobile]);

	useEffect(() => {
		// modal to confirm deletion of change
		if (modalAdditionalInfo && modalAdditionalInfo.changeId && modalAdditionalInfo.changeDeleteConfirmed) {
			contextDispatch({
				type: 'deleteChange', payload: {
					changeId: modalAdditionalInfo.changeId,
				},
			});
			setModalAdditionalInfo(null);
			closeModal();
		}
		// eslint-disable-next-line
    }, [modalAdditionalInfo]);

	return (<>{children}</>);
};

export default LetterLogic;
